




















































































































































































































































































































































// decoradores
import { Component, Vue, Watch } from "vue-property-decorator";
// vuex
import { mapActions, mapGetters } from "vuex";
// firebase
import { firebase } from "./config/firebase";
// tipos
import { Ruta } from "./typings/store/modules/rutas";
// componentes
import NavigationDrawer from "@/components/NavigationDrawer.vue";
import AppBar from "@/components/AppBar.vue";
import TabRutas from "@/components/TabRutas.vue";
//import { Promocion } from "@/typings/store/plugins/easyFirestore/promociones";
//import { Sesion } from "@/typings/store/plugins/easyFirestore/sesiones";
import Login from "@/components/Login.vue";
import FormularioInicioSesion from "@/components/login/cliente/FormularioInicioSesion.vue";
import { Usuario } from "@/typings/store/plugins/easyFirestore/usuarios";
import { Notificacion } from "@/typings/store/plugins/easyFirestore/notificaciones";
import DialogoExito from "@/components/DialogoExito.vue";
import FooterComponent from "./components/FooterComponent.vue";

@Component({
  computed: mapGetters({
    getUsuario: "usuario/get",
    getDrawer: "drawer/get",
    getRutasUsuario: "usuario/getRutas",
    getCargando: "cargando/get",
    getRutasArray: "rutas/getArray",
    // getArrayEmpresas: "empresas/getArray",
    //getArrayPromociones: "promociones/getArray",
    // getArraySesiones: "sesiones/getArray",
    getRutas: "rutas/get",
    getArrayNotificaciones: "notificaciones/getArray",
  }),
  methods: mapActions({
    setDrawer: "drawer/set",
  }),
  components: {
    DialogoExito,
    FormularioInicioSesion,
    Login,
    AppBar,
    TabRutas,
    NavigationDrawer,
    FooterComponent,
  },
})
export default class App extends Vue {
  mounted(): void {
    const guardado = localStorage.getItem("fidelmira-tema-oscuro");
    if (guardado !== null) {
      this.$vuetify.theme.dark = guardado === "true";
    }
  }

  toggleTema(): void {
    this.$vuetify.theme.dark = !this.$vuetify.theme.dark;
    localStorage.setItem("fidelmira-tema-oscuro", String(this.$vuetify.theme.dark));
  }

  menuNotificaciones = false;
  vistasVersion = 0;

  get claveNotificacionesVistas(): string {
    return `fidelmira-notif-vistas:${this.usuario?.id || "anon"}`;
  }

  @Watch("menuNotificaciones")
  onMenuNotificaciones(abierto: boolean): void {
    if (abierto) this.marcarNotificacionesVistas();
  }

  avisoParaUsuario(aviso: Notificacion, usuario: Usuario): boolean {
    const esOperacion = aviso.tipo.startsWith("orden-") || aviso.tipo.startsWith("prenomina-");
    if (!esOperacion) return false;
    const roles = ["admin", "supervisor", "relator", "gerente_operaciones", "gerente_general", "gerente_comercial"];
    if (!roles.includes(usuario.tipo)) return false;
    if (aviso.usuario?.id && aviso.usuario.id !== usuario.id) return false;
    return true;
  }

  fechaNotificacion(fecha: string): string {
    const valor = new Date(fecha);
    if (Number.isNaN(valor.getTime())) return "";
    return valor.toLocaleString("es-CL", {
      day: "2-digit",
      month: "short",
      hour: "2-digit",
      minute: "2-digit",
    });
  }

  marcarNotificacionesVistas(): void {
    if (!this.usuario?.id) return;
    const ids = new Set(this.idsNotificacionesVistas);
    this.notificacionesUsuario.forEach((aviso) => {
      if (aviso.id) ids.add(aviso.id);
    });
    localStorage.setItem(this.claveNotificacionesVistas, JSON.stringify([...ids].slice(-300)));
    this.vistasVersion += 1;
  }

  get puedeVerNotificaciones(): boolean {
    return !!this.usuario?.permisos?.notificaciones;
  }

  get notificacionesUsuario(): Notificacion[] {
    const usuario = this.usuario;
    if (!usuario) return [];
    return this.getArrayNotificaciones.filter((aviso: Notificacion) => this.avisoParaUsuario(aviso, usuario));
  }

  get notificacionesRecientes(): Notificacion[] {
    return [...this.notificacionesUsuario]
      .sort((a, b) => (b.fecha || "").localeCompare(a.fecha || ""))
      .slice(0, 6);
  }

  get notificacionesNuevas(): number {
    const vistas = new Set(this.idsNotificacionesVistas);
    return this.notificacionesUsuario.filter((aviso) => aviso.id && !vistas.has(aviso.id)).length;
  }

  get textoBadge(): string {
    return this.notificacionesNuevas > 9 ? "9+" : String(this.notificacionesNuevas);
  }

  get idsNotificacionesVistas(): string[] {
    return this.leerNotificacionesVistas(this.vistasVersion);
  }

  leerNotificacionesVistas(version: number): string[] {
    if (version < 0 || !this.usuario?.id) return [];
    try {
      const raw = localStorage.getItem(this.claveNotificacionesVistas);
      const parsed = raw ? JSON.parse(raw) : [];
      return Array.isArray(parsed) ? parsed.filter((id) => typeof id === "string") : [];
    } catch {
      return [];
    }
  }

  created(): void {
    if (!this.$route.name) {
      this.$router.replace({ name: "inicio" });
    }
    try {
      if (
        typeof Notification !== "undefined" &&
        typeof Notification.requestPermission === "function"
      ) {
        if (Notification.permission !== "granted") {
          Promise.resolve(Notification.requestPermission()).catch(() => undefined);
        }
      }
    } catch {
      /* Host sin Notifications completo (p. ej. algunos WKWebView) */
    }
  }

  dialogPrimeraVezLogin = false;
  dialogoLogin = false;
  dialogoExito = {
    model: false,
    icono: "",
    texto: "",
  };

  get drawer(): boolean {
    return this.getDrawer;
  }

  set drawer(data: boolean) {
    this.setDrawer(data);
  }

  get cargando(): boolean {
    return this.getCargando;
  }

  get vistaCargando(): boolean {
    return this.$store.getters["vistaCargando/get"] as boolean;
  }

  get usuario(): Usuario | null {
    return this.getUsuario;
  }

  get itemsRutas(): Array<Ruta> {
    return this.getRutasArray;
  }

  get rutasUsuario(): Array<Ruta> {
    return this.getRutasUsuario;
  }

  get tituloAppBar(): string {
    const nombreRuta = this.$route.name;
    if (!nombreRuta || nombreRuta === "principal") return "Inicio";
    for (const item of this.itemsLeft) {
      if (item.to?.name === nombreRuta) return item.title;
      const sub = item.subItems?.find((entrada) => {
        return typeof entrada.to !== "string" && entrada.to.name === nombreRuta;
      });
      if (sub) return sub.title;
    }
    const derecha = this.itemsRight.find((item) => item.to?.name === nombreRuta);
    if (derecha) return derecha.title;
    const ruta = this.itemsRutas.find((item) => item.to?.name === nombreRuta);
    return ruta?.text || "Sta. Fidelmira";
  }

  get etiquetaRol(): string {
    const roles: Record<string, string> = {
      admin: "Administrador",
      gerente_operaciones: "Gerente de operaciones",
      gerente_general: "Gerente general",
      gerente_comercial: "Gerente comercial",
      cliente: "Cliente",
      relator: "Relator",
      supervisor: "Supervisor",
      operador: "Operador",
      administrador_locales: "Administrador de locales",
    };
    return roles[this.usuario?.tipo || ""] || "Usuario";
  }

  get iniciales(): string {
    const partes = (this.usuario?.nombre || "").trim().split(/\s+/).filter(Boolean).slice(0, 2);
    if (partes.length === 0) return "U";
    return partes.map((parte) => parte.charAt(0).toUpperCase()).join("");
  }
  ///////////////////////////////////////77
  drawerLeft = false;
  drawerRight = false;
  itemsLeft: Array<{
    title: string;
    icon: string;
    to?: { name: string };
    expand: boolean;
    subItems?: Array<{
      title: string;
      to: { name: string } | string;
      external?: boolean;
    }>;
  }> = [
    {
      title: "Inicio",
      icon: "mdi-home-city-outline",
      to: { name: "inicio" },
      expand: false,
    },
    {
      title: "Ordenes de Compra",
      icon: "mdi-note-plus-outline",
      to: { name: "ordenes" },
      expand: false,
    },
    {
      title: "Empresas",
      icon: "mdi-office-building-outline",
      expand: false,
      subItems: [
        {
          title: "Inversiones NSF",
          to: "https://inversiones-insf.web.app",
          external: true,
        },
        {
          title: "Inversiones EWA",
          to: "https://inversiones-ewa.web.app",
          external: true,
        },
        {
          title: "Constructora ERG",
          to: "https://constructora-erg.web.app",
          external: true,
        },

        {
          title: "Ventas Florida Go",
          to: "https://ventas.iisf.cl",
          external: true,
        },
      ],
    },
    {
      title: "Egresos",
      icon: "mdi-account-cash-outline",
      expand: false,
      subItems: [
        { title: "Conciliación", to: { name: "registrosEgresos" } },
        // Oculto: era una copia de Prenómina que no funciona. Las notas de crédito de clientes se
        // registran desde Facturas; las de proveedores se rehacen más adelante.
        { title: "Prenomina", to: { name: "prenominas" } },
        { title: "Visualización de Pagos", to: { name: "visualizacionPagos" } },
      ],
    },
    {
      title: "Cajas Chicas",
      icon: "mdi-cash-multiple",
      expand: false,
      subItems: [
        {
          title: "Talca - Oficina Gerencial",
          to: { name: "cajaChicasTalcaGerencial" },
        },
        {
          title: "Talca - Oficinas",
          to: { name: "cajaChicasTalca" },
        },
        {
          title: "Talca - Mall Florida Go",
          to: { name: "cajaChicas" },
        },
        {
          title: "Linares",
          to: { name: "cajaChicasLinares" },
        },
        {
          title: "Santiago - Oficina",
          to: { name: "cajaChicasSantiagoOF" },
        },
        {
          title: "Santiago - Vicente Valdés",
          to: { name: "cajaChicasSantiagoVV" },
        },
      ],
    },
  ];
  itemsRight: Array<{
    title: string;
    to: { name: string };
    external?: boolean;
  }> = [
    { title: "Bancos", to: { name: "bancos" } },
    { title: "Centros de Costo", to: { name: "centrosCostos" } },
    { title: "Cuentas Softland", to: { name: "codCuentas" } },
    { title: "Mapeos", to: { name: "mapeoGastos" } },
    { title: "Proveedores", to: { name: "proveedores" } },
    { title: "Tipo Documento", to: { name: "tipoDocumentos" } },
    { title: "Tipo Gasto", to: { name: "tipoCargos" } },
    //===========================================================
    { title: "Clientes", to: { name: "clientes" } },
    { title: "Contratos", to: { name: "contratos" } },
    { title: "Facturas", to: { name: "facturas" } },
    { title: "Locales", to: { name: "locales" } },
    {
      title: "Condiciones Comerciales",
      to: { name: "condicionesComerciales" },
    },
    { title: "Condiciones Divisiones", to: { name: "condicionesDivisiones" } },
  ];

  toggleDrawerLeft(): void {
    this.drawerLeft = !this.drawerLeft;
  }

  toggleDrawerRight(): void {
    this.drawerRight = !this.drawerRight;
  }

  // eslint-disable-next-line
  toggleExpand(item: any): void {
    item.expand = !item.expand;
  }
  @Watch("usuario")
  onChangeUsuario(val: Usuario | null, old: Usuario | null): void {
    if (val == old) {
      return;
    }
    if (val) {
      if (
        (val && this.$route.name === "inicio") ||
        this.$route.name !== "inicio"
      ) {
        if (val.tipo === "admin") {
          this.$router.push({ name: "principal" });
        }
        if (val.tipo === "cliente") {
          // if (!val.nombre || !val.ciudad || !val.telefono || !val.rut) {
          //   this.dialogPrimeraVezLogin = true;
          // }
          this.$router.push({ name: "principal" });
        }
        if (val.tipo === "relator") {
          this.$router.push({ name: "principal" });
        }
      }
    }
  }

  loginError(data: string): void {
    if (data === "inhabilitado") {
      this.dialogoExito = {
        model: true,
        icono: require("./assets/icons/cancelar-duo.svg"),
        texto: "¡Usuario inhabilitado!",
      };
    }
  }

  cerrarDialogoExito(): void {
    this.dialogoExito = {
      model: false,
      icono: "",
      texto: "",
    };
  }

  logout(): void {
    firebase
      .auth()
      .signOut()
      .then(() => {
        this.$store.dispatch("usuario/set", null);
        this.$store.dispatch("cargando/set", false);
        this.$store.dispatch("drawer/set", false);
        this.$router.push({ name: "inicio" }).catch(() => undefined);
      });
  }
}
